// extracted by mini-css-extract-plugin
export default {"container":"CommentBg_container__aJMqU","isAiAssistant":"CommentBg_isAiAssistant__uS4mV","hidden":"CommentBg_hidden__+0Uia"};